'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NextImage from 'next/image';
import { AImage } from '../AImage';
import { getFormattedFileSize } from './MDownloadItem.helpers';
import { DownloadItem, Image, ImageContainer, MetaCollection, MetaItem, StyledHeadline, StyledIcon, StyledText, TextWrapper } from './MDownloadItem.styles';
export const MDownloadItem = ({ asset, className, downloadAsset, fileSize, frontify, headline, metaInfo, previewAlignment })=>{
    const file = asset?.[0];
    let imageUrl = file?.generic_url?.replace('?width={width}', '');
    let extension = file?.ext ?? '';
    let downloadUrl = file?.download_url;
    let isImageFile = new RegExp(/jpg|tif|png/).test(extension);
    let metaInfos = isImageFile ? [
        metaInfo || file?.description
    ] : [
        extension.toUpperCase(),
        getFormattedFileSize(Number(file?.filesize))
    ];
    if (downloadAsset?.filename) {
        downloadUrl = downloadAsset.filename;
        extension = new RegExp(/\.(\w+)$/).exec(downloadAsset.filename)?.[1] ?? '';
        isImageFile = new RegExp(/jpg|tif|png/).test(extension);
        metaInfos = isImageFile ? [
            metaInfo || extension.toUpperCase()
        ] : [
            extension.toUpperCase()
        ];
        imageUrl = downloadUrl;
        if (fileSize) {
            metaInfos.push(`${String(Math.round(Number(fileSize) / 1000) / 100).replace('.', ',')} MB`);
        }
    }
    if (frontify?.[0]?.downloadUrl) {
        downloadUrl = frontify[0].downloadUrl;
        extension = frontify[0].extension;
        isImageFile = frontify[0].type === 'Image';
        metaInfos = [
            extension.toUpperCase()
        ];
        imageUrl = frontify[0].previewUrl;
        if (frontify[0].size) {
            metaInfos.push(`${String(Math.round(Number(frontify[0].size) / 10000) / 100).replace('.', ',')} MB`);
        }
    }
    return /*#__PURE__*/ _jsxs(DownloadItem, {
        className: className,
        "data-testid": "download-item",
        download: true,
        href: downloadUrl,
        target: downloadAsset?.filename ? '_blank' : undefined,
        children: [
            isImageFile && typeof imageUrl === 'string' && /*#__PURE__*/ _jsx(ImageContainer, {
                children: /*#__PURE__*/ _jsx(Image, {
                    previewAlignment: previewAlignment,
                    children: frontify?.[0]?.previewUrl ? /*#__PURE__*/ _jsx(NextImage, {
                        alt: '',
                        height: frontify[0].height,
                        src: imageUrl,
                        width: frontify[0].width
                    }) : /*#__PURE__*/ _jsx(AImage, {
                        altText: (downloadAsset?.alt || file?.description) ?? '',
                        imageMobile: {
                            filename: imageUrl,
                            name: file?.title ?? '',
                            id: 0
                        }
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(TextWrapper, {
                children: [
                    /*#__PURE__*/ _jsxs(StyledText, {
                        children: [
                            /*#__PURE__*/ _jsx(StyledHeadline, {
                                renderAs: "p",
                                size: "S",
                                children: /*#__PURE__*/ _jsx("span", {
                                    children: headline ?? file?.title
                                })
                            }),
                            /*#__PURE__*/ _jsx(MetaCollection, {
                                children: metaInfos.map((meta)=>/*#__PURE__*/ _jsx(MetaItem, {
                                        size: "s",
                                        children: meta
                                    }, meta))
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(StyledIcon, {})
                ]
            })
        ]
    });
};

//# sourceMappingURL=MDownloadItem.js.map